"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var is_type_1 = require("./is-type");
var isDate = function (value) {
    return is_type_1.default(value, 'Date');
};
exports.default = isDate;
//# sourceMappingURL=is-date.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/lib/is-date.js
// module id = 1112
// module chunks = 37